import { render, staticRenderFns } from "./pwa_article_translates.vue?vue&type=template&id=b10c0f7a&scoped=true&"
import script from "./pwa_article_translates.vue?vue&type=script&lang=js&"
export * from "./pwa_article_translates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10c0f7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b10c0f7a')) {
      api.createRecord('b10c0f7a', component.options)
    } else {
      api.reload('b10c0f7a', component.options)
    }
    module.hot.accept("./pwa_article_translates.vue?vue&type=template&id=b10c0f7a&scoped=true&", function () {
      api.rerender('b10c0f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/news/modal/item/tabs/pwa_article_translates.vue"
export default component.exports